import { useRef } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { UploadCloud, Trash2 } from "lucide-react";
import { useApi } from "@/lib/useApi";
import { Button } from "@/components/ui/button";
import { useBranding, logoUrl } from "@/components/BrandMark";

export default function AdminBranding() {
  const api = useApi();
  const qc = useQueryClient();
  const input = useRef(null);
  const { data } = useBranding();
  const done = (msg) => (res) => { qc.setQueryData(["branding"], res); qc.invalidateQueries({ queryKey: ["branding"] }); toast.success(msg); };
  const err = (e) => toast.error(e.response?.data?.detail || "Errore");
  const upload = useMutation({
    mutationFn: async (file) => { const fd = new FormData(); fd.append("file", file); return (await api.post("/admin/branding/logo", fd, { headers: { "Content-Type": "multipart/form-data" } })).data; },
    onSuccess: done("Logo caricato"), onError: err,
  });
  const remove = useMutation({ mutationFn: async () => (await api.delete("/admin/branding/logo")).data, onSuccess: done("Logo rimosso"), onError: err });

  return (
    <div className="space-y-6 max-w-2xl">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Logo</h1>
        <p className="text-sm text-slate-500 mt-1">Il logo GoWeb compare nell'icona della scheda del browser, nel menu del portale e nell'intestazione dei PDF generati.</p>
      </div>
      <div className="bg-white border border-[#E2DDD5] rounded-xl p-6 flex items-center gap-6 flex-wrap">
        <div className="w-28 h-28 rounded-xl border border-dashed border-[#E2DDD5] bg-[#F9F8F6] flex items-center justify-center overflow-hidden" data-testid="branding-preview">
          {data?.has_logo ? <img src={logoUrl(data)} alt="Logo GoWeb" className="max-w-full max-h-full object-contain" /> : <span className="text-xs text-slate-400 text-center px-2">Nessun logo caricato</span>}
        </div>
        <div className="space-y-2">
          <input ref={input} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={(e) => { if (e.target.files?.[0]) upload.mutate(e.target.files[0]); e.target.value = ""; }} data-testid="branding-file-input" />
          <div className="flex gap-2">
            <Button disabled={upload.isPending} onClick={() => input.current?.click()} className="bg-[#B84A2B] hover:bg-[#983C21] text-white" data-testid="btn-upload-logo"><UploadCloud size={14} className="mr-1" /> {data?.has_logo ? "Sostituisci logo" : "Carica logo"}</Button>
            {data?.has_logo && <Button variant="outline" disabled={remove.isPending} onClick={() => remove.mutate()} data-testid="btn-remove-logo"><Trash2 size={14} className="mr-1" /> Rimuovi</Button>}
          </div>
          <p className="text-xs text-slate-500">PNG, JPG o WEBP, massimo 3 MB. Meglio quadrato e con sfondo trasparente.</p>
        </div>
      </div>
    </div>
  );
}
